import {Component, OnInit, forwardRef, Input, AfterViewInit, Injector, ChangeDetectorRef} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, NgControl } from '@angular/forms';
import { DocumentScannerModel } from '../document-scanner.model';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { PlatformService } from 'src/app/core-api/platform/platform.service';

@Component({
    selector: 'abw-document-scanner-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DocumentScannerFormComponent),
        multi: true
      }
    ],
    templateUrl: './document-scanner-form.component.html',
    styleUrls: ['./document-scanner-form.component.scss']
})
export class DocumentScannerFormComponent extends AbstractWorkflowFormComponent<DocumentScannerModel, string> {
    constructor(
      private platformService: PlatformService,
        _workflowComponentsService: WorkflowComponentsService,
        _cdf: ChangeDetectorRef,
        _injector: Injector
	) {
        super(_workflowComponentsService, _cdf, _injector);
    }

    async scanDocument() {
      try {
        const result = await this.platformService.scanDocument();
        this.onValueChanged(result);
      } catch(e) {
        console.error(e);
      }
    }
}